<template>
    <div class="container">
        <div class="incontainer">
            <div class="movie">
            <div class="movcontainer">
                <div class="movies">
                    <div class="movies-name">
                        <ul>
                            <li :class="{ active : selectedSongs.url == sound.url}"  v-for="(sound, index) in videoData" :key="index" @click="openSound(index)">
                               <a> {{ sound.title }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="movies-player" >
                        <div class="movies-player-video" v-if="selectedSongs">
                            <div class="movies-player-video-title">
                                <h4 >{{ selectedSongs.title }}</h4>
                            </div>
                            
                            <iframe  allowfullscreen  frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" class="iframe" :src="'https://www.youtube.com/embed/'+this.selectedSongs.url" controls></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
      </template>
      
      <script>
    
      export default {
        name:'albumDost',
        data() {
          return {
            videoData: [
              {
                title: 'Dost musun, Düşman mısın',
                url: '2j6-4-iEXHc'
              },
              {
                title: 'Çoçuk Oldum',
                url: '_DJFp1xImg4'
              },
              {
                title: 'Bana Güzel Bir Şey Söyle',
                url: '3Zf56fqduuM'
              },
              {
                title: 'Aldırma',
                url: 'OLl10HnikA0'
              },
              {
                title: 'Unuttum İşte',
                url: 'L3gSUvoXn8A'
              },
              {
                title: 'Gönül',
                url: 'YbVbIiS54bw'
              },
              {
                title: 'Çıkmaz Sokak',
                url: '5NA5hesfAyk'
              },
              {
                title: 'Bil ki Geri Dönmek Yok ',
                url: 'FYpY24g25dM'
              },
              {
                title: 'Yeter ki İste',
                url: 'Sfibgzmyo9U'
              },
              {
                title: 'Hayret Bir Şeysin',
                url: '0C1dCmRZPUk'
              },
              
              // diğer videolar
            ],
            selectedSongs: {
              title: 'Dost musun, Düşman mısın',
                url: '2j6-4-iEXHc'
          }
            
          };
        },
        methods:{
            openSound(index) {
                this.selectedSongs = this.videoData[index];
                console.log(this.selectedSongs.url)
            }
        }
      };
    
    
      </script>
      
      <style scoped>
    
    
      </style>
    
